import { render, staticRenderFns } from "./comparative-search.vue?vue&type=template&id=2cecc54f&"
import script from "./comparative-search.ts?vue&type=script&lang=ts&"
export * from "./comparative-search.ts?vue&type=script&lang=ts&"
import style0 from "./comparative-search.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports